import { render } from "./import-tasks.vue?vue&type=template&id=8cc6a67c&ts=true"
import script from "./import-tasks.vue?vue&type=script&lang=ts"
export * from "./import-tasks.vue?vue&type=script&lang=ts"

import "./import-tasks.vue?vue&type=style&index=0&id=8cc6a67c&lang=scss"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__